module.exports = __webpack_public_path__ + "static/media/Cavalier075_2c.bff1d91d.svg";